import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import RequestPage from "./pages/RequestPage";
import NewsletterPage from "./pages/NewsletterPage";

const App = () => {
  return (
    <>
      <ScrollToTop />
      <ToastContainer />
      <Routes>
        {/* Newsletter page */}
        <Route path="/newsletter" element={<NewsletterPage />} />

        {/* Car request page */}
        <Route path="/request" element={<RequestPage />} />

        {/* 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
